/* OIYK card color swatches: click a swatch to swap the card image (no navigation). */
(function () {
  if (window.__oiykSwatchInit) return;
  window.__oiykSwatchInit = true;

  function findCard(el) {
    return (
      el.closest('.custom-product-card') ||
      el.closest('.card-wrapper') ||
      el.closest('.grid__item') ||
      el.closest('li')
    );
  }

  function swap(sw) {
    var card = findCard(sw);
    if (!card) return;

    var img = sw.getAttribute('data-img');
    if (img) {
      var pic =
        card.querySelector('.custom-product-card__media img') ||
        card.querySelector('.card__media img') ||
        card.querySelector('img');
      if (pic) {
        pic.setAttribute('srcset', img);
        pic.setAttribute('src', img);
      }
    }

    var url = sw.getAttribute('data-url');
    if (url) {
      card
        .querySelectorAll('a.custom-product-card, .card__heading a, a.full-unstyled-link')
        .forEach(function (a) {
          a.setAttribute('href', url);
        });
    }

    if (sw.parentNode) {
      sw.parentNode
        .querySelectorAll('.oiyk-sw, .custom-product-card__swatch')
        .forEach(function (s) {
          s.style.boxShadow = '';
        });
    }
    sw.style.boxShadow = '0 0 0 2px #1c1c1c';
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var sw = t.closest('.oiyk-sw, .custom-product-card__swatch');
      if (!sw) return;
      if (!sw.getAttribute('data-img') && !sw.getAttribute('data-url')) return;
      e.preventDefault();
      e.stopPropagation();
      swap(sw);
    },
    true
  );
})();
